module.exports = __webpack_public_path__ + "static/img/video_ranking_list_avatar1.0d6b626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_ranking_list_avatar1.png
// module id = Zhki
// module chunks = 0